import { z } from 'zod';
/**
 * The console's runtime configuration, served at `/config.json`.
 *
 * Written by CD from the Auth, Api and Frontend stack outputs, so one bundle promotes across
 * environments with nothing environment-specific baked in at build time (§6.3).
 *
 * Nothing here is secret. A user pool id and a *public* SPA client id are designed to reach the
 * browser; the client has no secret, and every request is still authorised server-side by
 * role, org and ownership (§4).
 */
export const RuntimeConfigSchema = z.strictObject({
    environment: z.enum(['dev', 'test', 'prod']),
    region: z.string().min(1),
    /** Base URL of the REST API, no trailing slash. */
    apiUrl: z.url(),
    userPoolId: z.string().min(1),
    userPoolClientId: z.string().min(1),
    /** Cognito Hosted UI domain, host only — no scheme. */
    cognitoDomain: z.string().min(1),
});
//# sourceMappingURL=runtime-config.js.map